import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UmsService } from '../ums.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { DatePipe } from '@angular/common';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';

@Component({
  selector: 'app-ia-atd',
  templateUrl: './ia-atd.component.html',
  styleUrls: ['./ia-atd.component.scss']
})
export class IaAtdComponent implements OnInit {
  IAAttendanceForm: FormGroup;
  submitpayload: any;
  submitButton = true;
  editButton = false;
  showSubmitButton = true;
  Table = false;
  APIService: any;
  StudentTable: []; 
  colrChang = false;
  CountTable: [];
  StuArray: FormArray;
  dialogRef: MatDialogRef<any>;
  dialogRef1: MatDialogRef<any>;
  sessionList: any[];
  SessionFilterList: any[];
  sessionId = 0;
  CoCode = 0;
  CgCode = 0;
  CourseList: any;
  SaveBtn = false;
  UpdateBtn = false;
  filteredListCourse: any;
  collegeList: any;
  filteredCollegeList: any;
  CountTableForApp: any[];
  inteckCount: number;
  assignTableData: any[];
  Student: any;
  errMsg: any;
  currentDate: Date;
  // jsonData: any;
  examList
  filteredListExam
  subjectList = []
  filteredsubjectList
  isBranch = false;
  attendance = 0
  BranchList
filteredListBranch
emid
subcode
  savedpayload: any;
  SubAtdList: any;
  HeadList: any;
  filteredListHead: any;
  headcode: any;
  IaAtdCreate=true;
  IaAtdUpdate=true;
  userPermission: any;
  UserCollege
  utp: string;
  saveDisable: boolean;
  updateDisable: boolean;
  AttendCounts
  IsFile = false;
  constructor(private dialog: MatDialog,
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private fb: FormBuilder, public router: Router, private httpClient: HttpClient,
    private spinner: NgxSpinnerService, public datepipe: DatePipe,

  ) { this.APIService = environment.serviceUrl; }


  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');
    if(this.utp !== 'Super Admin' && this.utp !== 'Admin'){
      this.userPermission.forEach(element => {
      if(element.PageName == 'Student IA Attendance' && element.PCreate == false)
      {
          this.IaAtdCreate = false;  
      }
      if(element.PageName == 'Student IA Attendance' && element.PUpdate == false)
      {
          this.IaAtdUpdate = false;  
      }   
      
    });
  }
  this.IsFile= false
    this.saveDisable = false
    this.updateDisable = false
    this.SaveBtn = false;
    this.UpdateBtn = false;
    this.Table = false
    this.sessionId = 0;
    this.CoCode = 0;
    this.CgCode = 0;
    this.attendance = 0
    let id = ''
    this.submitButton = true;
    this.editButton = false;
    this.IAAttendanceForm = this.fb.group({
      college: new FormControl(''),
      course: new FormControl(''),
      SessionId: new FormControl(''),
      EmId: new FormControl(''),
      SubCode: new FormControl(''),
      EsId: new FormControl(''),
      Branch: new FormControl(''),
      EsParentId: new FormControl(''),
      StuArray: new FormArray([]),
    });
    this.fetchSession(id);
    this.getClg();
    this.currentDate = new Date();
  }

  getStuArrayControls() {
    return (this.IAAttendanceForm.get('StuArray') as FormArray).controls;
  }



  fetchSession(id) {
    this.spinner.show();
    const payload = {};
    this.filteredListCourse = [];
    this.filteredCollegeList = [];
    this.filteredListExam = [];
    this.filteredListBranch = [];
    this.filteredsubjectList = [];
    this.HeadList = [];
    payload['SnDefault'] = id;
    payload['SnNo'] = id;
    this.umsService.getSession(payload).subscribe(res => {
      this.spinner.hide();
      this.sessionList = [];
      if (res.status) {
        res.data.forEach(element => {
          if (element.SnStatus == 'O') {
            this.sessionList.push(element);
          }
        });
        this.SessionFilterList = this.sessionList.slice();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.sessionList = [];
    })
  }

  getCourse(data) {
    let payload2 = this.IAAttendanceForm.value
    this.Table = false
    this.UpdateBtn = false;
    this.SaveBtn = false;
    this.isBranch = false;
    this.Table = false;
    this.IAAttendanceForm.controls['course'].setValue('');
    this.IAAttendanceForm.controls['EmId'].setValue('');
    this.IAAttendanceForm.controls['EsParentId'].setValue('');
    this.IAAttendanceForm.controls['EsId'].setValue('');
    this.filteredListExam = [];
    this.filteredListBranch = [];
    this.filteredsubjectList = [];
    this.HeadList = [];
    this.examList = []
    this.CourseList = [];
    this.spinner.show();
    const payload = {};
    payload['CgCode'] = payload2.college;
    payload['SessionId'] = payload2.SessionId;
    
    // getSessionColgCo
    this.umsService.getCourse(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.CourseList = res.data;
        this.filteredListCourse = this.CourseList.slice();
      }
      else {
        this.spinner.hide();
        this.CourseList = [];
        this.filteredListCourse = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.CourseList = [];
    })
  }

  getClg() {
    if(this.userPermission[0].CgUi == 'C'){
      this.UserCollege= this.userPermission[0].CgId;
    }
    else{
      this.UserCollege = ''
    }
    this.Table = false;
    this.UpdateBtn = false;
    this.SaveBtn = false;
    this.subcode = '';
    this.filteredsubjectList =[];
    this.filteredListExam = []; 
    this.spinner.show();
    const payload = {};
    payload['CgCode'] = this.UserCollege
    this.umsService.getCollege(payload).subscribe(res => {
      this.spinner.hide();
      this.collegeList = res.data;
      this.filteredCollegeList = this.collegeList.slice();
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.collegeList = [];
    })
  }

  getHeadCode(data){
    this.headcode = data;
    this.ShowTable();
    this.IsFile= true
  }

  ShowTable() {
    this.spinner.show();
    this.Table = false;
    let payload2 = this.IAAttendanceForm.value
    this.StuArray = this.IAAttendanceForm.get('StuArray') as FormArray;
    this.StuArray.clear();
    this.assignTableData = [''];
    this.StudentTable = [];
    const payload = {};
    payload['SessionId'] = payload2.SessionId;
    payload['CoCode'] = payload2.course;
    payload['CgCode'] = payload2.college
    payload['EsParentId'] = payload2.EsParentId
    payload['EsCode'] = this.subcode;
    payload['HeadCode'] = this.headcode;
    payload['EmId'] = payload2.EmId
    this.umsService.getStuIAAtd(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.assignTableData = [''];
        this.Table = true;
        this.assignTableData = res.data;
        if (this.assignTableData[0]['AttendCount'] == null && this.assignTableData[0]['AttendStatus'] == null) {
          this.SaveBtn = true;
          this.UpdateBtn = false;
          this.getStudentDetails()
          // this.StuArray = this.AttendanceForm.get('StuArray') as FormArray;
          // this.StuArray['Status'].setValue('Y');
        }
        else {
          this.SaveBtn = false;
          this.UpdateBtn = true;
         
        }
        this.assignTableData.forEach((element, i) => {
          const creds = this.IAAttendanceForm.get('StuArray') as FormArray;
          creds.push(
            this.fb.group({
              SrNo: new FormControl(i + 1),
              Name: new FormControl(element['StuFullNameEng']),
              Attendance: new FormControl(element['AttendCount'], [Validators.pattern('^(?:[0-9]{1,3})(?:\.[0-9]{1,2})?$'), Validators.max(100), Validators.required]),
              Status: new FormControl(element['AttendStatus']),
              StuId: new FormControl(element['StuId']),
              SctId: new FormControl(element['ScrutinyId']),
              AttendIAId: new FormControl(element['AttendIAId']),
            })
          );
        });
       
        this.getStuAtdSet()

      } else {
        if (res.message == 'No Data Found') {
          this.spinner.hide();
          this.StudentTable = [];
          this.Table = false;
          this.SaveBtn = false;
          this.UpdateBtn = false;
          let data = {}
        data['message'] = 'No data found for this filter'
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
        });
        }

      }

    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.SaveBtn = false;
      this.UpdateBtn = false;
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Alert'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      
      // this.umsService.openSnackbar(ERROR.error.message);

    });

  }

  getStudentDetails(){

  }

  addNewRow() {
    const creds = this.IAAttendanceForm.controls.StuArray as FormArray;
    creds.push(
      this.fb.group({
        SrNo: new FormControl(''),
        Name: new FormControl(''),
        Attendance: new FormControl('', [Validators.pattern('^(?:[0-9]{1,3})(?:\.[0-9]{1,2})?$'), Validators.max(100), Validators.required]),
        Status: new FormControl('N'),
        StuId: new FormControl(''),
        SctId: new FormControl('')
      })
    );
  }

  onInputChange2(val, i) {
    this.saveDisable = false
    this.updateDisable = false
    const tempData = val.target.value;
    let taskListArrays = this.IAAttendanceForm.get('StuArray') as FormArray;
    
    if(tempData > 100){
      if(this.SaveBtn == true){
        this.saveDisable = true
      }
      else if(this.UpdateBtn == true){
        this.updateDisable = true
      }
    }
    else{
      if(this.SaveBtn == true){
        this.saveDisable = false
      }
      else if(this.UpdateBtn == true){
        this.updateDisable = false
      }
    }
    // if(tempData > 100){
    //   this.LessThan(this.StuArray)
    //   if(this.SaveBtn == true){
    //     this.saveDisable = true
    //   }
    //   else if(this.UpdateBtn == true){
    //     this.updateDisable = true
    //   }
    // }
    if (tempData == '') {
      this.StuArray = this.IAAttendanceForm.get('StuArray') as FormArray;
      this.StuArray.at(i).get('Status').setValue('N');
    }
    
    let data = this.SubAtdList.find(item => item.EsCode === this.subcode);
    
    if(tempData >= data.Attendance){
      this.StuArray = this.IAAttendanceForm.get('StuArray') as FormArray;
      this.StuArray.at(i).get('Status').setValue('Y');
    }
    if(tempData > data.Attendance){
      this.StuArray = this.IAAttendanceForm.get('StuArray') as FormArray;
      this.StuArray.at(i).get('Status').setValue('Y');
    }
    if(tempData == data.Attendance){
      this.StuArray = this.IAAttendanceForm.get('StuArray') as FormArray;
      this.StuArray.at(i).get('Status').setValue('Y');
    }
    else if(tempData < data.Attendance){
      this.StuArray = this.IAAttendanceForm.get('StuArray') as FormArray;
      this.StuArray.at(i).get('Status').setValue('N');
    }
   
  }

  redirect(to): void {
    this.router.navigate([to]);
  }

  errorcheckR(i) {
    return i.controls['Attendance'].touched && i.controls['Attendance'].errors?.pattern
  }

  LessThan(i) {
    return i.controls['Attendance'].touched && i.controls['Attendance'].errors?.max
  }

  Save(){
    if (this.IAAttendanceForm.invalid) {
      this.IAAttendanceForm.get('SessionId').markAsTouched();
      this.IAAttendanceForm.get('college').markAsTouched()
      this.IAAttendanceForm.get('course').markAsTouched();
      this.IAAttendanceForm.get('EmId').markAsTouched();
      this.IAAttendanceForm.get('EsParentId').markAsTouched();
      this.IAAttendanceForm.get('EsId').markAsTouched();
      this.StuArray = this.IAAttendanceForm.get('StuArray') as FormArray;
      if (this.StuArray.invalid) {
        this.StuArray.controls.forEach(element => {
          element.get('Attendance').markAsTouched();
        })
      }
    }
    else {
      this.SaveAtd()
    }
  }

  SaveAtd() {
    this.spinner.show();
    this.submitpayload = this.IAAttendanceForm.value;
    this.IAAttendanceForm.controls.StuArray as FormArray;
    this.StuArray = this.IAAttendanceForm.get('StuArray') as FormArray;
    this.Student = this.StuArray.value
    // let payload = abcd.value;
    let iserror = false;
    var bar = new Promise<void>((resolve, reject) => {
      this.Student.forEach((element, index, array) => {
        let payload = {};  
        payload['SessionID'] = this.submitpayload['SessionId'];
        payload['CgCode'] = this.submitpayload['college'];
        payload['CoCode'] = this.submitpayload['course'];
        payload['EmId'] = this.submitpayload['EmId'];
        payload['EsId'] = this.submitpayload['EsId'];
        payload['EsParentId'] = this.submitpayload['EsParentId'];
        payload['HeadCode'] = this.headcode;
        payload['SubCode'] = this.subcode;
        payload['Branch'] = this.submitpayload['Branch'];
        payload['StuID'] = element.StuId;
        payload['AttendCount'] = parseInt(element.Attendance) ? parseInt(element.Attendance):'';
        payload['AttendStatus'] = element.Status ? element.Status : '';
        payload['ScrutinyID'] = element.SctId;
        payload['UserID'] = parseInt(sessionStorage.getItem('userId'));
        payload['EntryDateTime'] = this.currentDate;
        this.umsService.saveStuIAAtd(payload).subscribe(res => {
          this.spinner.hide();
          if (res.status == false) {
            iserror = true;
            this.errMsg = res.message
          }
          if (index === array.length - 1) resolve();
          else {
            iserror = false
            this.errMsg = res.message
          }
        }, (ERROR: HttpErrorResponse) => {
          iserror = true;
          this.errMsg = ERROR.error.message
          if (index === array.length - 1) resolve();
        });
      });
    })
    bar.then(() => {
      if (iserror == false) {
        let data = {}
        data['message'] = "Submitted Successfully"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          this.ShowTable()
        });

      } else {
        let data = {}
        data['message'] = this.errMsg
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          this.ShowTable()
        });
      }
    });
  }

  update(){
    if (this.IAAttendanceForm.invalid) {
      this.IAAttendanceForm.get('SessionId').markAsTouched();
      this.IAAttendanceForm.get('college').markAsTouched();
      this.IAAttendanceForm.get('course').markAsTouched();
      this.IAAttendanceForm.get('EmId').markAsTouched();
      this.IAAttendanceForm.get('EsParentId').markAsTouched();
      this.IAAttendanceForm.get('EsId').markAsTouched();
      this.StuArray = this.IAAttendanceForm.get('StuArray') as FormArray;
      if (this.StuArray.invalid) {
        this.StuArray.controls.forEach(element => {
          element.get('Attendance').markAsTouched();
        })
      }
    }
    else {
      this.updateAtd()
    }
  }

  updateAtd() {
    // updateStdAtd
    this.spinner.show();
    this.submitpayload = this.IAAttendanceForm.value;
    this.IAAttendanceForm.controls.StuArray as FormArray;
    this.StuArray = this.IAAttendanceForm.get('StuArray') as FormArray;
    this.Student = this.StuArray.value
    let iserror = false;
    var bar = new Promise<void>((resolve, reject) => {
      this.Student.forEach((element, index, array) => {
        let payload = {};
        payload['SessionID'] = this.submitpayload['SessionId'];
        payload['CgCode'] = this.submitpayload['college'];
        payload['CoCode'] = this.submitpayload['course'];
        payload['EmId'] = this.submitpayload['EmId'];
        payload['EsId'] = this.submitpayload['EsId'];
        payload['EsParentId'] = this.submitpayload['EsParentId'];
        payload['HeadCode'] = this.headcode;
        payload['SubCode'] = this.subcode;
        payload['Branch'] = this.submitpayload['Branch'];
        payload['StuID'] = element.StuId;
        payload['AttendCount'] = parseInt(element.Attendance);
        payload['AttendStatus'] = element.Status;
        payload['ScrutinyID'] = element.SctId;
        payload['AttendIAId'] = element.AttendIAId;
        payload['UserID'] = sessionStorage.getItem('userId');
        payload['EntryDateTime'] = this.currentDate;
        this.umsService.updateStuIAAtd(payload).subscribe(res => {
          this.spinner.hide();
          if (res.status == false) {
            iserror = true;
            this.errMsg = res.message
          }
          if (index === array.length - 1) resolve();
          else {
            iserror = false
            this.errMsg = res.message
          }
        }, (ERROR: HttpErrorResponse) => {
          iserror = true;
          this.errMsg = ERROR.error.message
          if (index === array.length - 1) resolve();
        });
      });
    })
    bar.then(() => {
      if (iserror == false) {
        let data = {}
        data['message'] = "Updated Successfully"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          this.ShowTable()
        });
      } else {
        let data = {}
        data['message'] = this.errMsg
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          this.ShowTable()
        });
      }
    });
  }



  getExamList(e) {
    this.Table = false;
    this.spinner.show();
    this.filteredsubjectList =[];
    this.examList = []
    this.isBranch = false;
    const payload = {};
    payload['EmCoCode'] = e;
    this.filteredsubjectList =[];
    this.examList = []
    this.umsService.getExam(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.examList = res.data;
        this.filteredListExam = this.examList.slice();
      }
      else {
        this.spinner.hide();
        let data = {}
        data['message'] = res.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Alert'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.ngOnInit();
      // this.umsService.openSnackbar(ERROR.error.message);

    });
  }



  getSubject(e) {
    this.isBranch = false;
    this.Table = false;
    this.filteredListBranch = [];
    this.filteredsubjectList = [];
    this.HeadList = [];
    this.IAAttendanceForm.controls['EsId'].setValue('');
    this.subjectList = []
    this.emid = e.EmId;
     if (e.EmStreams == "Y") {
      this.spinner.hide();
      this.isBranch = true;
      this.fetchBranch(e.EmId);
      // this.emid = e.EmId;
    }else{
      this.isBranch = false;
      const payload = {};
      payload['EsEmId'] = e.EmId;
      payload['EsStrId'] = 0;
      this.umsService.getExamSubMapFetch(payload).subscribe(res => {
        res.data.children.forEach(element => {
          if(element.EsType == 'S'){
            this.subjectList.push(element)
          }
          else if(element.EsType =='G'){
            element.children.forEach(grpSub => {
               this.subjectList.push(grpSub)
            });
          }
          this.filteredsubjectList = this.subjectList.slice();
        });
      });
    }
   
  }


  fetchBranch(id) {
    const payload = {};
    this.filteredsubjectList =[];
    this.subjectList = [];
    this.HeadList = [];
    this.IAAttendanceForm.controls['EsId'].setValue('');
    payload['EmId'] = id;
    this.umsService.getExamStream(payload).subscribe(res => {
      if (res.status) {
        this.BranchList = res.data;
        this.filteredListBranch = this.BranchList.slice();
      }
    });
  }


  getStr(e) {
    this.Table = false;
    this.filteredsubjectList = [];
    this.subjectList=[]
    this.HeadList = [];
    let payload = {};
    payload['EsEmId'] = this.emid;
    payload['EsStrId'] = this.IAAttendanceForm.value.Branch;
    this.umsService.getExamSubMapFetch(payload).subscribe(res => {
      if(res.status){
        res.data.children.forEach(element => {
          if(element.EsType == 'S'){
            this.subjectList.push(element)
          }
          else if(element.EsType =='G'){
            element.children.forEach(grpSub => {
               this.subjectList.push(grpSub)
            });
          }
          this.filteredsubjectList = this.subjectList.slice();
        });
      }
      else{
        this.subjectList = [];
        this.filteredsubjectList = [];

      }
     
    }, (ERROR: HttpErrorResponse) => {
      this.subjectList = [];
      this.filteredsubjectList = [];
    });
  }

  subjectClick(data){
    this.HeadList = [];
    this.filteredListHead = [];
    this.Table = false;
    this.subcode = data.EsCode;
    const payload = {};
    payload['EsId'] = data.EsId;
    this.umsService.getStuIASub(payload).subscribe(res => {
      if(res.status){
        this.HeadList = res.data;
        this.filteredListHead = this.HeadList.slice();
      }
      else{
        this.HeadList = [];
        this.IAAttendanceForm.controls['EsId'].setValue('');

      }
      
    }, (ERROR: HttpErrorResponse) => {
      this.HeadList = [];
      this.IAAttendanceForm.controls['EsId'].setValue('');
    })
  }

  getStuAtdSet(){
    this.spinner.show();
    this.savedpayload = this.IAAttendanceForm.value
    this.SubAtdList = []
    this.attendance = 0
    const payload = {};
    payload['CgCode'] = this.savedpayload.college;
    payload['EsParentId'] = this.savedpayload.EsParentId;
    payload['CoCode'] = this.savedpayload.course;
    payload['EmId'] = this.savedpayload.EmId;
    payload['StrId'] = this.savedpayload.Branch;
    payload['SessionId'] = this.savedpayload.SessionId;
    this.umsService.getStuIAAtdSet(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.SubAtdList = res.data;
        let data = this.SubAtdList.find(item => item.EsCode === this.subcode);
        this.attendance = data.Attendance;
        if(data.Attendance == null){
          let data = {}
          data['message'] = 'IA Attendance Threshold Not Entered For This Subject.'
          data['title'] = 'Alert'
          data['icon'] = 'fas fa-close'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.saveDisable = true
        }
        else{
          this.saveDisable = false;
        }
      }
      else {
        this.spinner.hide();
        let data = {}
        data['message'] = 'No IA Attendance Threshold For This Subject.'
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.saveDisable = true
      }



    });
  }



  File(event: any) {
 
    const data = {};
    data['message'] = 'Do You Want To Upload This File ?';
    data['title'] = 'Information';
    data['icon'] = 'fa fa-question';
    this.dialogRef =
      this.modalPopupService.openPopup<ConformationModelComponent>(
        ConformationModelComponent,
        data
      );
    this.dialogRef.afterClosed().subscribe((result) => {
      if (result === 'yes') {
        this.dialogRef.close();
        const files: FileList = event.target.files;
        const allowedExtensions = ['csv'];
   
        if (files && files.length > 0) {
          for (let i = 0; i < files.length; i++) {
            const file: File = files[i];
            const extension = file.name.split('.').pop().toLowerCase();
   
            if (allowedExtensions.includes(extension)) {
              // Process the selected file here (e.g., read its content or upload it)
              // let data = {};
              // data['message'] = 'File Uploaded Successfully';
              // data['title'] = 'Information';
              // data['icon'] = 'fas fa-check';
              // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
              //   AlertBoxComponent,
              //   data
              // );
              // this.SearchEditMarks();
              // this.ControlLock2(parseInt(this.LoginId));
              this.getTextFromFile(file);
   
            } else {
            }
          }
        }
      }
      else {
        this.dialogRef.close();
      }
    });
 
 
 
   
  }
  importDataFromCSV(csvText: string): Array<any> {
    const propertyNames = csvText.slice(0, csvText.indexOf('\n')).split(',');
    const dataRows = csvText.slice(csvText.indexOf('\n') + 1).split('\n');
    let dataArray: any[] = [];
    dataRows.forEach((row) => {
      let values = row.split(',');
      let obj: any = new Object();
      for (let index = 0; index < propertyNames.length; index++) {
        const propertyName: string = propertyNames[index];
        let val: any = values[index];
        if (val === '') {
          val = parseInt;
        }
        obj[propertyName] = val;
      }
      dataArray.push(obj);
    });
    return dataArray;
  }
  async getTextFromFile(file) {
    // const file: File = event.target.files[0];
    let fileContent = await file.text();
    const importedData = this.importDataFromCSV(fileContent);
    this.processCsvContents(importedData.slice(0,importedData.length-1));
}
///
  processCsvContents(dataArray): void {
    let AttendanceCounttt = this.attendance;
    let iserror = false;
    var bar = new Promise<void>((resolve, reject) => {
    dataArray.forEach((element, index, array) => {
      const userId: string | null = sessionStorage.getItem('userId');
      const entryDateTime: Date = this.currentDate;
      element.UserID = userId;
      element.EntryDateTime = entryDateTime;
      element.SessionID = this.IAAttendanceForm.value.SessionId;
      element.EmId = this.IAAttendanceForm.value.EmId;
      element.EsId = this.IAAttendanceForm.value.EsId;
      element.EsParentId =this.IAAttendanceForm.value.EsParentId;
      element.HeadCode =this.headcode;
      element.CoCode = this.IAAttendanceForm.value.course;
      element.CgCode = this.IAAttendanceForm.value.college
      element.SubCode= this.subcode;
      element.Branch = this.IAAttendanceForm.value.Branch;
      if(AttendanceCounttt == parseInt(element['AttendCount']) || parseInt(element['AttendCount']) > AttendanceCounttt){
        element['AttendStatus'] = 'Y'
      }
      else{
        element['AttendStatus'] = 'N'
      }
      this.AttendCounts = this.assignTableData[0]['AttendCount'] ;
      this.assignTableData[0]['AttendCount']
      element['AttendCount'] = parseInt(element['AttendCount']);
       element['ScrutinyID'] = 0;
      // return
      if(this.AttendCounts == '' ||  this.assignTableData[0]['AttendCount'] == null){
        this.umsService.saveStuIAAtd(element).subscribe((res) => {
          if (res.status == false) {
            iserror = true;
            this.errMsg = res.message
          }
          if (index === array.length - 1) resolve();
          else {
            iserror = false
            this.errMsg = res.message
           
          }
          },(ERROR: HttpErrorResponse) => {
            this.spinner.hide();
            
          });
      }else{
        this.umsService.updateStuIAAtd(element).subscribe((res) => {
          if (res.status == false) {
            iserror = true;
            this.errMsg = res.message
          }
          if (index === array.length - 1) resolve();
          else {
            iserror = false
            this.errMsg = res.message
            this.ngOnInit()
          }
        }, (ERROR: HttpErrorResponse) => {
          this.spinner.hide();
         
        });
      }
     
    });
  })
  bar.then(() => {
    if (iserror == false) {
      let data = {}
      data['message'] = "Uploaded Successfully"
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.dialogRef.afterClosed().subscribe((result) => {
        this.ShowTable()
      });

    } else {
      let data = {}
      data['message'] = this.errMsg
      data['title'] = 'Alert'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.dialogRef.afterClosed().subscribe((result) => {
        // this.ShowTable()
      });
    }
  });
  }
 
  dowload()
  {
    const link=document.createElement("a");
     link.href='../../assets/excel/IA Attendance 2.csv';
     link.download='Download';
     link.click()
  }


  download2(event: Event) {
    event.preventDefault();
    const extractedData = this.assignTableData.map(element => ({
      StuID: element.StuId,
      Name: element.StuFullNameEng,
      AttendCount: element.AttendCount,
      // AttendStatus: element.AttendStatus,
      Branch:element.EsStrId,
      ScrutinyID: 0,
     }));

    // Convert array data to CSV format
    const csvContent = this.convertArrayToCSV(extractedData);
    // Create a Blob
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    
    // Create a URL for the Blob
    const url = window.URL.createObjectURL(blob);
    
    // Create a download link
    const link = document.createElement('a');
    link.href = url;
    link.download = 'data.csv'; // You can change the file name if needed
    document.body.appendChild(link);
    
    // Trigger the download
    link.click();
}

convertArrayToCSV(array) {
    const header = Object.keys(array[0]).join(',');
    const rows = array.map(obj => Object.values(obj).map(value => `"${value}"`).join(','));
    return [header, ...rows].join('\n');
}
}
